enum LayerName {
    CrossSectionLayer = 'crossSectionLayer',
    ShadowLayer = 'shadowLayer',
    ImageBaseLayer = 'imageBaseLayer',
    BaseMapsLayer = 'basemaps',
    GeoLayer = 'geoLayer',
    TrackingLayer = 'trackingLayer',
    BaseMapLayer = 'baselayer',
    BaseMapLayerWithLabels = 'baselayer-with-labels',
    ARENALayer = 'arena-layer',
    CTRLayer = 'ctr-layer',
    FIRLayer = 'fir-layer',
    Coastline = 'coastline-layer',
    PrealoadingGeoLayer = '_geoLayer',
    PlanePathLayer = 'pathLayer',
    ASDBLayer = 'ADSBLayer',
}

export default LayerName;
